"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_toggle_1 = require("../checkbox/awsui-toggle");
var awsui_form_field_1 = require("../form-field/awsui-form-field");
var BaseCollectionContentSelectorWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionContentSelectorWrapper, _super);
    function BaseCollectionContentSelectorWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionContentSelectorWrapper.prototype.findTitle = function () {
        var formField = new awsui_form_field_1.default(this.find('awsui-form-field').getElement());
        return formField.findLabel();
    };
    BaseCollectionContentSelectorWrapper.prototype.findOptionsGroups = function () {
        return this.findAll(".awsui-" + this.name + "-content-selector-options-group");
    };
    BaseCollectionContentSelectorWrapper.prototype.findOptions = function () {
        return this.findAll(".awsui-" + this.name + "-content-selector-option");
    };
    /**
     * Returns a content selector toggle.
     *
     * @param groupIndex 1-based index of the content group to look in.
     * @param optionIndex 1-based index of the option to return.
     */
    BaseCollectionContentSelectorWrapper.prototype.findToggleByIndex = function (groupIndex, optionIndex) {
        // we need to skip option group header element
        var childIndex = optionIndex + 1;
        var optionsGroup = ".awsui-" + this.name + "-content-selector-options-group:nth-child(" + groupIndex + ")";
        var option = ".awsui-" + this.name + "-content-selector-option:nth-child(" + childIndex + ")";
        var element = this.find(optionsGroup + " " + option + " awsui-toggle");
        return element ? new awsui_toggle_1.default(element.getElement()) : null;
    };
    return BaseCollectionContentSelectorWrapper;
}(dom_1.ComponentWrapper));
exports.BaseCollectionContentSelectorWrapper = BaseCollectionContentSelectorWrapper;
var TableContentSelectorWrapper = /** @class */ (function (_super) {
    __extends(TableContentSelectorWrapper, _super);
    function TableContentSelectorWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'table';
        return _this;
    }
    return TableContentSelectorWrapper;
}(BaseCollectionContentSelectorWrapper));
exports.default = TableContentSelectorWrapper;
//# sourceMappingURL=awsui-table-content-selector.js.map